import { Users } from '../store/users/api/interfaces';

const DISPLAY_MAX_LENGTH = 50;

export const getCurrentNationalityInference = (user: Users | undefined | null) =>
  user?.user_nationality_inferences?.[0];

export const getInferredNationalityLabel = (user: Users | undefined | null): string => {
  const value = getCurrentNationalityInference(user)?.primaryCountry?.trim();
  return value || '-';
};

export const getInferredNationalityDisplay = (
  user: Users | undefined | null,
  maxLength = DISPLAY_MAX_LENGTH
): string => {
  const label = getInferredNationalityLabel(user);
  if (label === '-' || label.length <= maxLength) {
    return label;
  }

  return `${label.slice(0, maxLength - 1)}…`;
};

export const shouldShowNationalityTooltip = (
  user: Users | undefined | null,
  maxLength = DISPLAY_MAX_LENGTH
): boolean => {
  const label = getInferredNationalityLabel(user);
  return label !== '-' && label.length > maxLength;
};

export const getInferredNameOrigin = (user: Users | undefined | null): string => {
  const value = getCurrentNationalityInference(user)?.nameOrigin?.trim();
  return value || '-';
};
